import { useEffect, useState } from 'react';
import dynamicfunction from '../../utils/dynamicfunction';
import { useNavigate, useSearchParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { createAccount, downloadAccountOpeningTerms, getApplicationTypes } from '../../store/actions/accountOpeningAction';
import { getContentKeyAccToLang } from '../../utils/utils';
import dayjs from 'dayjs';
import { setApplicationId, setLanguage } from '../../store/slices/contentSlice';
import { languages } from '../../config/config';

export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [searchParams, setSearchParams] = useSearchParams();

  const { TextWeight, isArabic } = dynamicfunction();
  const { applicationTypeDropdown, applicationTypeDropdownLoading, accountOpeningLoading } = useSelector((state) => state.accountOpening);
  const authContent = useSelector((state) => state.content?.authContent);
  const { common_loading } = useSelector((state) => state.common);
  const [type, setType] = useState(null);
  const [restrictModal, setRestrictModal] = useState(false);
  const [resumeModal, setResumeModal] = useState(false);

  useEffect(() => {
    const languageId = searchParams.get('languageId');
    const language = languageId ? Number(languageId) : isArabic ? 2 : 1
    if (languageId === '1') {
      dispatch(setLanguage({ language: languages.eng }));
    } else if (languageId === '2') {
      dispatch(setLanguage({ language: languages.arb }));
    }

    if (languageId) {
      setSearchParams((prev) => {
        const params = new URLSearchParams(prev);
        params.delete('languageId');
        return params;
      }, { replace: true });
    }

    dispatch(getApplicationTypes(language))
  }, [isArabic, searchParams])

  const getContentKey = (key) => {
    return getContentKeyAccToLang(authContent?.web_create_account?.data?.attributes, key, isArabic);
  };

  const handleSubmit = (values) => {
    const data = {
      crNo: values?.unified_number,
      emailAddress: values?.email?.trim()?.toLowerCase(),
      mobileNumber: `${values?.country?.dial_code ?? ""}${values?.phone_number ?? ""}`,
      applicantTypeId: values?.entity_type?.id,
      languageId: isArabic ? 2 : 1,
      cr_expiry: dayjs(values.cr_expiry).format("YYYY-MM-DD"),
      IsTermsAndPrivacyPolicyAccepted: Boolean(values?.is_terms_accepted),
      // companyTypeId: 1133
    }

    dispatch(createAccount(data, (res) => {
      dispatch(setApplicationId(res?.result?.corpClientApplicationId))
      navigate("/otp-verification");
    }));

  }

  // documentType: 1 = Terms and Conditions, 2 = Privacy Policy
  const handleDownloadTerms = (documentType) => {
    dispatch(downloadAccountOpeningTerms({ languageId: isArabic ? 2 : 1, documentType }));
  }

  return { TextWeight, isArabic, type, setType, navigate, restrictModal, setRestrictModal, resumeModal, setResumeModal, handleSubmit, handleDownloadTerms, applicationTypeDropdown, applicationTypeDropdownLoading, getContentKey, accountOpeningLoading, common_loading };
}
